import { useEffect, useState } from "react";
import { ICON_FONT_FAILURE_EVENT } from "@/lib/iconCdnFallback";

// 本会话内用户点过「我已了解」后不再重复弹出（刷新页面会重置 —— 因为刷新是新的加载过程，
// 图标是否恢复值得重新判定一次）。
const ACK_STORAGE_KEY = "icon-font-notice-acked";

function readAcked(): boolean {
  try {
    return sessionStorage.getItem(ACK_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

// 当全站图标字体（Remix Icon / Font Awesome）全部加载失败时，页面里的图标会变成空白框。
// 这里给出一个温和的顶部提示，说明原因并提供刷新 / 了解操作。
// 注意：提示本身不使用图标字体，避免「没图标可显示」的尴尬。
export default function IconFontFallbackNotice() {
  const [failed, setFailed] = useState(false);
  const [dismissed, setDismissed] = useState(readAcked);

  useEffect(() => {
    if (dismissed) return undefined;
    const handler = () => setFailed(true);
    window.addEventListener(ICON_FONT_FAILURE_EVENT, handler);
    return () => window.removeEventListener(ICON_FONT_FAILURE_EVENT, handler);
  }, [dismissed]);

  const acknowledge = () => {
    try {
      sessionStorage.setItem(ACK_STORAGE_KEY, "1");
    } catch {
      // 存储不可用时仅本次隐藏，不阻塞使用
    }
    setDismissed(true);
  };

  if (!failed || dismissed) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[80] flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border-b border-background-300 bg-background-100 px-4 py-2.5 text-center text-xs text-foreground-800">
      <span className="inline-flex items-center gap-2">
        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-100 font-semibold text-accent-800">
          !
        </span>
        图标资源加载失败，可刷新重试
        <span className="hidden text-foreground-500 sm:inline">
          （网络或拦截插件可能挡住了图标字体 CDN，界面功能不受影响）
        </span>
      </span>
      <span className="inline-flex items-center gap-2">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="cursor-pointer whitespace-nowrap rounded-md border border-primary-300 bg-primary-50 px-3 py-1 text-[11px] font-medium text-primary-700 transition-colors hover:bg-primary-100"
        >
          刷新重试
        </button>
        <button
          type="button"
          onClick={acknowledge}
          title="本次会话内不再提示"
          className="cursor-pointer whitespace-nowrap rounded-md px-2 py-1 text-[11px] text-foreground-500 transition-colors hover:text-foreground-800"
        >
          我已了解
        </button>
      </span>
    </div>
  );
}